var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListviewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8004 17.936H6.7522C6.09077 17.936 5.55469 17.3942 5.55469 16.7258C5.55469 16.0574 6.09077 15.5156 6.7522 15.5156H22.8C23.4614 15.5156 23.9975 16.0574 23.9975 16.7258C23.9975 17.3942 23.4618 17.936 22.8004 17.936Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8082 10.3422H6.76001C6.09858 10.3422 5.5625 9.80048 5.5625 9.13206C5.5625 8.46363 6.09858 7.92188 6.76001 7.92188H22.8078C23.4692 7.92188 24.0053 8.46363 24.0053 9.13206C24.0057 9.80048 23.4696 10.3422 22.8082 10.3422Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8004 2.74068H6.7522C6.09077 2.74068 5.55469 2.19892 5.55469 1.53049C5.55469 0.862071 6.09077 0.320312 6.7522 0.320312H22.8C23.4614 0.320312 23.9975 0.862071 23.9975 1.53049C23.9975 2.19892 23.4618 2.74068 22.8004 2.74068Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60825 3.25055C2.49647 3.25055 3.21651 2.52289 3.21651 1.62527C3.21651 0.72766 2.49647 0 1.60825 0C0.720039 0 0 0.72766 0 1.62527C0 2.52289 0.720039 3.25055 1.60825 3.25055Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60825 10.7505C2.49647 10.7505 3.21651 10.0229 3.21651 9.12527C3.21651 8.22766 2.49647 7.5 1.60825 7.5C0.720039 7.5 0 8.22766 0 9.12527C0 10.0229 0.720039 10.7505 1.60825 10.7505Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60825 18.2584C2.49647 18.2584 3.21651 17.5307 3.21651 16.6331C3.21651 15.7355 2.49647 15.0078 1.60825 15.0078C0.720039 15.0078 0 15.7355 0 16.6331C0 17.5307 0.720039 18.2584 1.60825 18.2584Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListviewIcon);
export default __webpack_public_path__ + "static/media/listviewIcon.4825dc65449b789842da626e7c3fcdf8.svg";
export { ForwardRef as ReactComponent };